const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column'
    },
    questionApplicationContent: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: '35vh'
    },
    formControl: {
        margin: theme.spacing(0)
    },
    group: {
        margin: `${theme.spacing(1)}px 0`
    },
    headerImageWrapper: {
        position: 'relative',
        margin: -theme.spacing(1) * 2,
        marginBottom: theme.spacing(0),
        marginTop: theme.paper ? -theme.paper.paddingTop : -theme.spacing(1) * 3,
        [theme.breakpoints.up(600)]: {
            margin: -theme.spacing(1) * 4,
            marginTop: -theme.spacing(1) * 4,
            marginBottom: theme.spacing(1)
        }
    },
    headerImage: {
        maxWidth: '100%'
    },
    prelanderCompletedMessageWrapper: {
        padding: theme.spacing(1),
        '& p:last-child': {
            marginBottom: 0
        }
    },
    questionPageFooterTextWrapper: {
        marginTop: theme.spacing(1),
        padding: theme.spacing(0, 0.25),
        '& p:last-child': {
            marginBottom: 0
        }
    },
    extraElementsLinkWrapper: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        display: 'flex'
    },
    extraElementsLink: {
        margin: 'auto',
        padding: '1px 6px',
        textTransform: 'none',
        color: 'white!important'
    },
    buttons: {
        marginTop: theme.layoutAlias === 'premium-exclusive' ? theme.spacing(1) : theme.spacing(2),
        marginBottom: 0,
        paddingBottom: '0!important'
    },
    button: {
        width: '100%',
        fontWeight: theme.forwardButton ? theme.forwardButton.fontWeight : 500,
        marginRight: theme.spacing(1.5),
        marginBottom: theme.spacing(1),
        color: '#fff!important',
        boxShadow: theme.button ? theme.button.boxShadow : null,
        borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius : 32
    },
    completedPageButton: {
        marginBottom: 90
    },
    [theme.breakpoints.down(600)]: {
        buttons: {
            padding: '4px!important'
        },
        button: {
            padding: '8px 24px!important'
        },
        completedPageButton: {
            marginBottom: 0
        }
    },
    rightIcon: {
        marginLeft: theme.spacing(1.5),
        marginTop: theme.spacing(0.75),
        marginBottom: theme.spacing(0.75),
        marginRight: -theme.spacing(1) * 0.5
    },
    radio: {
        minWidth: '110px'
    },
    selectButton: {
        marginTop: theme.spacing(1.7),
        marginRight: theme.spacing(2),
        minWidth: '112px'
    },
    logoImg: {
        filter: 'grayscale(100%)',
        opacity: 0.5
    },
    questionWrapper: {
        marginBottom: theme.spacing(2),
        flexGrow: 1
    },
    imageWrapper: {
        width: '100%',
        textAlign: 'center',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    image: {
        maxWidth: '100%',
        height: 'auto'
    },
    dialog: {
        margin: '0 -24px!important'
    },
    dialogTitle: {
        marginTop: '12px!important',
        marginBottom: '-8px!important',
        fontSize: '1.2rem!important',
        lineHeight: 1.15
    },
    questionContainer: {
        width: 'calc(100% + 16px)',
        margin: '-8px',
        [theme.breakpoints.down(600)]: {
            width: 'calc(100% + 8px)',
            margin: '-4px'
        }
    },
    footerProgressBar: {
        marginTop: 33,
        borderRadius: 0,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
        height: '9px !important',
        boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12);'
    },
    hideOnDesktop: {
        [theme.breakpoints.up(600)]: {
            display: 'none'
        }
    },
    prelanderAnswerWrapper: {
        display: 'flex',
        justifyContent: 'center',
        margin: theme.spacing(0, -1),
        flexDirection: 'column',
        textAlign: 'center'
    },
    prelanderAnswer: {
        margin: theme.spacing(0.375, 0.5),
        padding: theme.spacing(0.25, 1),
        background: theme.palette.primary.main,
        color: '#fff',
        borderRadius: 32,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        [theme.breakpoints.up(600)]: {
            padding: theme.spacing(0.5, 1),
            margin: theme.spacing(0.5, 0.5),
            fontSize: '1rem'
        }
    },
    wheelContainer: {
        //backgroundImage: 'linear-gradient(360deg, #4158D0 0%, #C850C0 20%, #C850C0 60%, #FFCC70 90%, #f9f9f9 100%)', //Deeper colors
        //backgroundImage: 'linear-gradient(360deg, #91a2ff 0%, #cf63c8 20%, #e28add 60%, #fffe97 90%, #f9f9f9 100%)',
        backgroundImage: 'linear-gradient(360deg, #91acff 0%, #8dd2f5 20%, #c5e3ff 60%, #ddf8ff 90%, #f9f9f9 100%)',
        paddingTop: 78,
        marginTop: -60,
        paddingLeft: 4,
        paddingRight: 4
    }
})

export { styles }
